<template>
  <div
    class="reporrtsmain"
    data-tst="reports_main"
  >
    <div class="reporrtsmain_item">
      <StudyReportsLoader
        v-if="showReportsLoader"
        :isPending="isReportsLoaderPending"
        :isDisabled="isReportsLoaderDisabled"
        :currentSolutionsCount="$store.getters.rep_data_customReportMeta.solved_board_count"
        :totalBoardCount="$store.getters.rep_data_customReportMeta.total_board_count"
      />
      <RepChartControls
        v-if="['chart', 'cells'].some(k => content.includes(k))"
        class="std_cont swp_cont_stop"
        style="--height: var(--controls-height); width: 100%"
        :hero="hero"
        :opponent="opponent"
        :actions="solution"
        :grouping="grouping"
        :viewProps="viewProps"
        :showBetsIn="showBetsIn"
        :showEvIn="bettingInfo.showEvIn"
        :flopGroup="controlsFlopGroup"
        @touchend.stop
      />
      <StudyReportsIncompleteMessage v-if="hasReportsIncompleteMessage" />
      <RepChart
        v-if="content.includes('chart')"
        :namespace
        class="anim-fade-in std_cont"
        :items="items.filter(i => !i.isEmpty)"
        :totalsItems="totalsItems"
        :legendVertical="legendVertical"
        :useHex="useHex"
        :bettingInfo
        :playerRelPosition="playerRelPosition"
        :reportItemId="reportItemId"
        :showBetsIn="showBetsIn"
        :hero="hero"
        :opponent="opponent"
        :viewProps="viewProps"
        :grouping="grouping"
        :solution="solution"
        :eveqeqrAxes="eveqeqrAxes"
        :flopGroup="flopGroup"
        :navResizeDeps="navResizeDeps"
        :flopBoard="flopBoard"
        :hasNav="flopGroup === 'swv_flops'"
        :hasLinks="hasLinks"
        :linkParams="linkParams"
      />
      <RepTable
        v-if="content.includes('table')"
        :namespace
        class="std_cont"
        :solution="solution"
        :items="items.filter(i => !i.isEmpty)"
        :totalsItems="totalsItems"
        :grouping="grouping"
        :flopGroup="flopGroup"
        :viewProps="viewProps"
        :showBetsIn="showBetsIn"
        :hero="hero"
        :opponent="opponent"
        :reportItemId="reportItemId"
        :bettingInfo
        :useHex="useHex"
        :colorCoding="colorCoding"
        :navResizeDeps="navResizeDeps"
        :flopBoard="flopBoard"
        :hasNav="flopGroup === 'swv_flops'"
        :isInfinite="flopGroup === 'swv_flops'"
        :hasLinks="hasLinks"
        :linkParams="linkParams"
      />
      <RepTurnCells
        v-if="content.includes('cells')"
        class="anim-fade-in std_cont"
        style="flex: none"
        :items="items"
        :solution="solution"
        :isPreflop="isPreflop"
        :useHex="useHex"
        :grouping="grouping"
        :filterCombos="filterCombos"
        :showBetsIn="showBetsIn"
        :reportItemId="reportItemId"
        :hasPremiumGameformat="hasPremiumGameformat"
        :gameformat="gameformat"
        :viewProps="viewProps"
        :bettingInfo
        :hSpot="hSpot"
        :street="street"
        :mobile="mobile"
        :flopGroup="flopGroup"
        :flopBoard="flopBoard"
      />
    </div>
  </div>
</template>

<script>
import RepChart from '@/components/DataTables/v2/tables/reports/RepChart'
import RepTable from '@/components/DataTables/v2/tables/reports/RepTable'
import RepTurnCells from '@/components/DataTables/v2/tables/reports/RepTurnCells'
import RepChartControls from '@/components/DataTables/v2/tables/reports/RepChartControls'
import { SNK } from '@/helpers/helpers'
import StudyReportsIncompleteMessage from './StudyReportsIncompleteMessage.vue'
import StudyReportsLoader from './StudyReportsLoader.vue'

export default {
  name: 'StudyReportsMain',

  components: {
    RepChart,
    RepTable,
    RepTurnCells,
    RepChartControls,
    StudyReportsIncompleteMessage,
    StudyReportsLoader,
  },
  props: {
    namespace: { required: true, type: String },
    items: Array,
    totalsItems: Array,
    legendVertical: Boolean,
    useHex: Boolean,
    colStyleKey: String,
    playerRelPosition: String,
    isPreflop: Boolean,
    reportItemId: String,
    hero: Object,
    opponent: Object,
    viewProps: Object,
    flopGroup: String,
    controlsFlopGroup: String,
    eveqeqrAxes: Object,
    solution: Array,
    grouping: String,
    showBetsIn: String,
    bettingInfo: Object,
    // street: String,
    content: String,
    colorCoding: String,
    navResizeDeps: Object,
    filterCombos: Object,
    mobile: Boolean,
    street: String,
    hSpot: Object,
    hasPremiumGameformat: Boolean,
    gameformat: Object,
    flopBoard: String,
    hasLinks: { default: true, type: Boolean },
    hasReportsIncompleteMessage: Boolean,
    linkParams: Object,
  },
  data() {
    return {}
  },
  computed: {
    showReportsLoader() {
      return (
        this.$store.getters[SNK('sol_usingCussolReports', this.namespace)] &&
        this.$store.getters.rep_data_customReportMeta.status !== 'done'
      )
    },
    isReportsLoaderPending() {
      return (
        this.$store.getters.rep_data_customReportMeta.status === 'pending' &&
        !this.$store.getters.rep_data_customReportMeta.solved_board_count
      )
    },
    isReportsLoaderDisabled() {
      const status = this.$store.getters.rep_data_customReportMeta.status
      return status === 'not_exist' || status === 'cancelled' || status === 'failed'
    },
  },
}
</script>
<style lang="scss" scoped>
.reporrtsmain {
  --controls-height: 2.75rem;
  --gap: var(--laytsttd-gap, 0.5rem);
  gap: var(--gap);

  flex-direction: column;
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  &_item {
    gap: var(--gap);
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    min-width: 0;
    padding: var(--laytsttd-padding-content);
    background: var(--clr-black-1);
    border-radius: 6px;
    position: relative;
  }
}
</style>
